export default {
  amulet_01: require('./images/amulet_01.png'),
  amulet_02: require('./images/amulet_02.png'),
  amulet_03: require('./images/amulet_03.png'),
  amulet_04: require('./images/amulet_04.png'),
  amulet_05: require('./images/amulet_05.png'),
  amulet_06: require('./images/amulet_06.png'),
  amulet_07: require('./images/amulet_07.png'),
  amulet_08: require('./images/amulet_08.png'),

  engine_01: require('./images/engine_01.jpg'),
  engine_02: require('./images/engine_02.jpg'),
  engine_03: require('./images/engine_03.jpg'),
  engine_04: require('./images/engine_04.jpg'),
  engine_05: require('./images/engine_05.jpg'),

  freedive_01: require('./images/freedive_01.jpg'),
  freedive_02: require('./images/freedive_02.jpg'),
  freedive_03: require('./images/freedive_03.jpg'),
  freedive_04: require('./images/freedive_04.jpg'),
  freedive_05: require('./images/freedive_05.jpg'),
  freedive_06: require('./images/freedive_06.jpg'),
  freedive_07: require('./images/freedive_07.jpg'),
  freedive_08: require('./images/freedive_08.jpg'),

  hmall_01: require('./images/hmall_01.png'),
  hmall_02: require('./images/hmall_02.png'),
  hmall_03: require('./images/hmall_03.png'),
  hmall_04: require('./images/hmall_04.png'),
  hmall_05: require('./images/hmall_05.png'),
  hmall_06: require('./images/hmall_06.png'),
  hmall_07: require('./images/hmall_07.png'),

  hmall_m_01: require('./images/hmall_m_01.png'),
  hmall_m_02: require('./images/hmall_m_02.png'),
  hmall_m_03: require('./images/hmall_m_03.png'),
  hmall_m_04: require('./images/hmall_m_04.png'),
  hmall_m_05: require('./images/hmall_m_05.png'),
  hmall_m_06: require('./images/hmall_m_06.png'),
  hmall_m_07: require('./images/hmall_m_07.png'),

  itms_app_01: require('./images/itms_app_01.png'),
  itms_app_02: require('./images/itms_app_02.png'),
  itms_app_03: require('./images/itms_app_03.png'),
  itms_app_04: require('./images/itms_app_04.png'),
  itms_app_05: require('./images/itms_app_05.png'),
  itms_app_06: require('./images/itms_app_06.png'),
  itms_app_07: require('./images/itms_app_07.png'),
  itms_app_08: require('./images/itms_app_08.png'),

  itms_web_01: require('./images/itms_web_01.png'),
  itms_web_02: require('./images/itms_web_02.png'),
  itms_web_03: require('./images/itms_web_03.png'),
  itms_web_04: require('./images/itms_web_04.png'),
  itms_web_05: require('./images/itms_web_05.png'),
  itms_web_06: require('./images/itms_web_06.png'),
  itms_web_07: require('./images/itms_web_07.png'),
  itms_web_08: require('./images/itms_web_08.png'),
  itms_web_09: require('./images/itms_web_09.png'),
  itms_web_10: require('./images/itms_web_10.png'),
  itms_web_11: require('./images/itms_web_11.png'),

  kind_01: require('./images/kind_01.png'),
  kind_02: require('./images/kind_02.png'),
  kind_03: require('./images/kind_03.png'),
  kind_04: require('./images/kind_04.png'),
  kind_05: require('./images/kind_05.png'),

  mocean_01: require('./images/mocean_01.png'),
  mocean_02: require('./images/mocean_02.png'),
  mocean_03: require('./images/mocean_03.png'),
  mocean_04: require('./images/mocean_04.png'),
  mocean_05: require('./images/mocean_05.png'),
  mocean_06: require('./images/mocean_06.png'),
  mocean_07: require('./images/mocean_07.png'),
  mocean_08: require('./images/mocean_08.png'),
  mocean_09: require('./images/mocean_09.png'),
  mocean_10: require('./images/mocean_10.png'),
  mocean_11: require('./images/mocean_11.png'),

  random_dog_01: require('./images/random_dog_01.jpg'),
  random_dog_02: require('./images/random_dog_02.jpg'),
  random_dog_03: require('./images/random_dog_03.jpg'),
  random_dog_04: require('./images/random_dog_04.jpg'),

  whatailsyou_01: require('./images/whatailsyou_01.png'),
  whatailsyou_02: require('./images/whatailsyou_02.png'),
  whatailsyou_03: require('./images/whatailsyou_03.png'),
  whatailsyou_04: require('./images/whatailsyou_04.png'),
  whatailsyou_05: require('./images/whatailsyou_05.png'),
  whatailsyou_06: require('./images/whatailsyou_06.png'),
  whatailsyou_07: require('./images/whatailsyou_07.png'),
  whatailsyou_08: require('./images/whatailsyou_08.jpg'),

  youngmap_01: require('./images/youngmap_01.png'),
  youngmap_02: require('./images/youngmap_02.png'),
  youngmap_03: require('./images/youngmap_03.png'),
  youngmap_04: require('./images/youngmap_04.png'),
  youngmap_05: require('./images/youngmap_05.png'),
  youngmap_06: require('./images/youngmap_06.png'),
  youngmap_07: require('./images/youngmap_07.png'),
  youngmap_08: require('./images/youngmap_08.png'),
};
